import { createRecipe } from './runtime.js';

const adornmentButtonConfig = {"name":"adornmentButton"}

export const adornmentButton = /* @__PURE__ */ createRecipe(adornmentButtonConfig)